import { type WithChildren } from "@client/types/WithChildren";
import * as React from "react";

export type Props = WithChildren & {
  style: React.CSSProperties;
};
export default (props: Props) => (
  <div id="wsc_sp_container" style={props.style}>
    {props.children}
  </div>
);
